function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99992 0.333008C3.31992 0.333008 0.333252 3.31967 0.333252 6.99968C0.333252 10.6797 3.31992 13.6663 6.99992 13.6663C10.6799 13.6663 13.6666 10.6797 13.6666 6.99968C13.6666 3.31967 10.6799 0.333008 6.99992 0.333008ZM6.99992 12.333C4.05992 12.333 1.66659 9.93968 1.66659 6.99968C1.66659 4.05967 4.05992 1.66634 6.99992 1.66634C9.93992 1.66634 12.3333 4.05967 12.3333 6.99968C12.3333 9.93968 9.93992 12.333 6.99992 12.333ZM9.35992 4.87967L6.05992 8.17968L4.64659 6.76634C4.38659 6.50634 3.96659 6.50634 3.70659 6.76634C3.44659 7.02634 3.44659 7.44634 3.70659 7.70634L5.59325 9.59301C5.85325 9.85301 6.27325 9.85301 6.53325 9.59301L10.3066 5.81967C10.5666 5.55967 10.5666 5.13967 10.3066 4.87967C10.0399 4.61967 9.61992 4.61967 9.35992 4.87967Z",
  fill: "#EF753F"
});
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d29517c87b2f83c1677e44cc3c96da1a.svg";
export { ForwardRef as ReactComponent };